<template>
  <div>
    <v-snackbar v-model="localShowSnackbar" bottom right color="success" :timeout="timeout">
      {{ snackbarText }}
    </v-snackbar>

    <v-snackbar v-model="localShowSnackbarError" bottom right color="error" :timeout="timeout">
      {{ snackbarErrorText }}
    </v-snackbar>
  </div>
</template>

<script>
export default {
  props: {
    showSnackbar: Boolean,
    snackbarText: String,
    showSnackbarError: Boolean,
    snackbarErrorText: String,
    timeout: {
      type: Number,
      default: 1000
    }
  },
  data() {
    return {
      localShowSnackbar: this.showSnackbar,
      localShowSnackbarError: this.showSnackbarError
    };
  },
  watch: {
    showSnackbar(newValue) {
      this.localShowSnackbar = newValue;
    },
    showSnackbarError(newValue) {
      this.localShowSnackbarError = newValue;
    },
    localShowSnackbar(newValue) {
      if (!newValue) {
        this.$emit('update:showSnackbar', false);
      }
    },
    localShowSnackbarError(newValue) {
      if (!newValue) {
        this.$emit('update:showSnackbarError', false);
      }
    }
  }
}
</script>
